/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityReportedAssetResult } from './MonitEntityReportedAssetResult';
import {
    MonitEntityReportedAssetResultFromJSON,
    MonitEntityReportedAssetResultFromJSONTyped,
    MonitEntityReportedAssetResultToJSON,
} from './MonitEntityReportedAssetResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityReportedAssetsResponse
 */
export interface MonitPaginatedEntityReportedAssetsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityReportedAssetsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityReportedAssetsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityReportedAssetsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityReportedAssetResult>}
     * @memberof MonitPaginatedEntityReportedAssetsResponse
     */
    results?: Array<MonitEntityReportedAssetResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityReportedAssetsResponse interface.
 */
export function instanceOfMonitPaginatedEntityReportedAssetsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityReportedAssetsResponseFromJSON(json: any): MonitPaginatedEntityReportedAssetsResponse {
    return MonitPaginatedEntityReportedAssetsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityReportedAssetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityReportedAssetsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityReportedAssetResultFromJSON)),
    };
}

export function MonitPaginatedEntityReportedAssetsResponseToJSON(value?: MonitPaginatedEntityReportedAssetsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityReportedAssetResultToJSON)),
    };
}

